import { ConfiguratorDesignCategory } from '../types';
import { CONFIGURATOR_DEFAULT_LOCALE } from './locale';

export const CONFIGURATOR_DESIGN_THEME_CATEGORY: ConfiguratorDesignCategory = {
  id: 'theme',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Theme',
  },
};

export const CONFIGURATOR_DESIGN_COLORS_CATEGORY: ConfiguratorDesignCategory = {
  id: 'colors',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Colors',
  },
};

export const CONFIGURATOR_DESIGN_ART_CATEGORY: ConfiguratorDesignCategory = {
  id: 'art',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Art Style',
  },
};

export const CONFIGURATOR_DESIGN_CATEGORIES: ConfiguratorDesignCategory[] = [
  CONFIGURATOR_DESIGN_THEME_CATEGORY,
  CONFIGURATOR_DESIGN_COLORS_CATEGORY,
  CONFIGURATOR_DESIGN_ART_CATEGORY,
];

export const CONFIGURATOR_DESIGN_DEFAULT_CATEGORY = CONFIGURATOR_DESIGN_THEME_CATEGORY;

export const CONFIGURATOR_DESIGN_EXPANDED_STATE = CONFIGURATOR_DESIGN_CATEGORIES.reduce<Record<string, boolean>>(
  (map, category) => ({
    ...map,
    [category.id]: false,
  }),
  {},
);

export const CONFIGURATOR_DESIGN_THEME_MIN_SIZE = 3;

export const CONFIGURATOR_DESIGN_COLORS_MIN_SIZE = 5;

export const CONFIGURATOR_DESIGN_ART_MIN_SIZE = 3;
